Postlogin = (function (postlogin) {
    postlogin.GroupsList = {};
    const self = postlogin.GroupsList;
    const myGroupsSelect = document.getElementById('my-groups');
    const sharedGroupsSelect = document.getElementById('shared-groups');
    const exportGroupsButton = document.getElementById('export-groups');
    let selectedType = 'mine';

    self.init = function () {
        initBootstrapTable();

        myGroupsSelect.addEventListener('click', selectFilter);
        sharedGroupsSelect.addEventListener('click', selectFilter);
        exportGroupsButton.addEventListener('click', exportGroups);
    };

    const groupsListTable = $('#groups-list-table');
    const groupViewUrl = groupsListTable.data('group-view-url');
    const groupEditUrl = groupsListTable.data('group-edit-url');
    const groupDeleteUrl = groupsListTable.data('group-delete-url');

    // Set the active tab explicitly rather than toggling both tabs: a blind
    // toggle marked both <li>s active on the first click (and neither on the
    // second), so the highlight stopped matching the table contents.
    const setActiveTab = (activeTab) => {
        [myGroupsSelect, sharedGroupsSelect].forEach((tab) => {
            const isActive = tab === activeTab;
            tab.parentNode.classList.toggle('active', isActive);
            if (isActive) {
                tab.setAttribute('aria-current', 'true');
            } else {
                tab.removeAttribute('aria-current');
            }
        });
    };

    const selectFilter = (event) => {
        // href="#" would otherwise jump and leave /groups/# in the address bar
        event.preventDefault();

        const tab = event.currentTarget;
        const type = tab.dataset?.type;
        if (!type || type === selectedType) {
            return;
        }

        selectedType = type;
        setActiveTab(tab);
        groupsListTable.bootstrapTable('refresh');
    };

    const exportGroups = () => {
        const opts = groupsListTable.bootstrapTable('getOptions');
        const exportParams = {
            columns: _.map(groupsListTable.bootstrapTable('getVisibleColumns'), (col) => [col.title, col.field]),
            sortName: opts.sortName,
            sortOrder: opts.sortOrder,
            type: selectedType,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };

        window.open(`${Slim.Router.urlFor('Groups.list.export')}?${$.param(exportParams)}`, '_blank');
    };

    const initBootstrapTable = function () {
        const columns = [
            {
                title: 'Name',
                field: 'name',
                align: 'center',
                valign: 'middle',
                sortable: true,
                class: 'group-name',
            },
            {
                title: 'Owner',
                field: 'last_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                formatter(value, row) {
                    if (value) {
                        return `${row.first_name} ${row.last_name}`.trim();
                    }

                    return '--';
                },
            },
            {
                title: '# of Members',
                field: 'users_count',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value, row) {
                    return `
                        <a href="${groupViewUrl.replace(':group_id', row.group_id)}" class="btn btn-hollow-dark-gray">
                            ${value} Group Members
                        </a>
                    `;
                },
            },
            {
                title: 'Group Code',
                field: 'easy_code',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Created',
                field: 'date_created',
                align: 'left',
                valign: 'middle',
                sortable: true,
                formatter(value) {
                    return new Date(value).toLocaleDateString('en-us', 'L');
                },
            },
            {
                title: 'Shared',
                field: 'shared',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
                formatter(value) {
                    return value ? '<i class="fa fa-check-circle text-success" aria-hidden="true"></i>' : '';
                },
            },
            {
                title: 'Actions',
                field: 'actions',
                align: 'center',
                valign: 'middle',
                sortable: false,
                formatter(value, row) {
                    const viewButton = `
                        <a href="${groupViewUrl.replace(':group_id', row.group_id)}" class="btn btn-hollow-green">View</a>
                    `;

                    if (row.can_manage) {
                        const deleteUrl = groupDeleteUrl.replace(':group_id', row.group_id);
                        const editUrl = groupEditUrl.replace(':group_id', row.group_id);

                        return `
                            ${viewButton}
                            <a href="${editUrl}" class="btn btn-hollow-blue">Edit</a>
                            <form action="${deleteUrl}" method="post" class="delete-entry">
                                <input type="hidden" name="csrf_token" value="${Jr.getCsrfToken()}">
                                <input type="hidden" name="_METHOD" value="DELETE"/>
                                <button type="submit" class="btn btn-hollow-pink">Delete</button>
                            </form>
                        `;
                    }

                    return viewButton;
                },
            },
        ];

        groupsListTable.bootstrapTable({
            formatNoMatches() {
                return 'No groups to show';
            },
            method: 'post',
            contentType: 'application/x-www-form-urlencoded',
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'user_id',
            minimumCountColumns: '2',
            pagination: true,
            search: true,
            sortName: 'shared',
            sortOrder: 'asc',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            searchAlign: 'left',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: '/groups/data/',
            pageSize: 25,
            queryParamsType: '',
            queryParams(params) {
                return { ...params, type: selectedType };
            },
            columns,
            responseHandler(res) {
                return {
                    total: res.meta.total,
                    rows: res.data,
                };
            },
            onLoadSuccess() {
                $('time.timeago').timeago();
            },
        });
    };

    return postlogin;
}(Postlogin || {}));
